module.exports = __webpack_public_path__ + "img/home.1dd7f894.svg";